module.exports = __webpack_public_path__ + "static/media/configurator-city_elements.53e74069.png";